import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTopics } from "../lib/api";
import { SectionTitle, Loader } from "../components/Shared";
import * as Icons from "lucide-react";

export default function Library() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getTopics()
      .then(setData)
      .finally(() => setLoading(false));
  }, []);

  const open = (t) => navigate(`/chat?topic=${encodeURIComponent(t)}`);

  return (
    <div className="max-w-7xl mx-auto px-5 md:px-10 py-8 md:py-12" data-testid="library-page">
      <SectionTitle kicker="Topic library" title="50 STEM models · 4 mythology streams" subtitle="Tap any topic to start a chat about it." />

      {loading && <Loader label="Loading library…" />}

      {data && (
        <>
          <div className="mb-12">
            <h3 className="font-heading text-xl font-bold mb-5 text-[#1A1A1A]" data-testid="library-stem-heading">STEM modules</h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {data.stem_modules.map((m, i) => {
                const Icon = Icons[m.icon] || Icons.Sparkles;
                return (
                  <div key={m.name} className="card p-6" data-testid={`stem-card-${i}`}>
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 rounded-lg bg-[#EAECE6] grid place-items-center text-[#3A5A40]">
                        <Icon size={18} />
                      </div>
                      <div className="font-heading font-semibold text-lg">{m.name}</div>
                    </div>
                    <div className="flex flex-wrap gap-1.5">
                      {m.models.map((t, j) => (
                        <button
                          key={j}
                          onClick={() => open(t)}
                          data-testid={`stem-topic-${i}-${j}`}
                          className="text-xs bg-[#F4F1EA] border border-[#DCD7CE] hover:border-[#E07A5F] hover:text-[#E07A5F] px-2.5 py-1 rounded-full transition"
                        >
                          {t}
                        </button>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-xl font-bold mb-5 text-[#1A1A1A]" data-testid="library-myth-heading">Mythology &amp; moral tales</h3>
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {data.mythology.map((m, i) => {
                const Icon = Icons[m.icon] || Icons.BookOpen;
                return (
                  <div key={m.name} className="card p-6" data-testid={`myth-card-${i}`}>
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-10 h-10 rounded-lg bg-[#FBE7DF] grid place-items-center text-[#E07A5F]">
                        <Icon size={18} />
                      </div>
                      <div className="font-heading font-semibold text-lg">{m.name}</div>
                    </div>
                    <div className="flex flex-wrap gap-1.5">
                      {m.topics.map((t, j) => (
                        <button
                          key={j}
                          onClick={() => open(t)}
                          data-testid={`myth-topic-${i}-${j}`}
                          className="text-xs bg-[#F4F1EA] border border-[#DCD7CE] hover:border-[#3A5A40] hover:text-[#3A5A40] px-2.5 py-1 rounded-full transition"
                        >
                          {t}
                        </button>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
